/**
 * Zoho Projects SPA links: load canvas before issue detail so parent shell runs first.
 * 1. Removes `/issues/{issueId}` when it appears immediately before `/issue-detail/...`.
 * 2. Rewrites `#zp/projects/{projectId}/issue-detail/...` →
 *    `#zp/projects/{projectId}/canvas/all/issue-detail/...` when `canvas/all` is absent.
 */
export function normalizeZohoIssueLinkUrl(url: string): string {
  if (!url || typeof url !== 'string') return url;

  let out = url;
  // Drop /issues/{id} segment (Zoho sometimes includes it before issue-detail)
  out = out.replace(/\/issues\/[^/]+(?=\/issue-detail)/gi, '');

  // if (!out.includes('/canvas/all/')) {
  //   out = out.replace(/(#zp\/projects\/[^/]+)\/(issue-detail\/)/i, '$1/canvas/all/$2');
  // }

  return out;
}

/** Open in a new tab without referrer (helps Zoho redirect when embedded). */
export const zohoIssueLinkProps = {
  target: '_blank' as const,
  rel: 'noopener noreferrer',
};
